import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'
import type UnassignedShift from 'modules/shift_management/store/api/models/UnassignedShift'

export const useCanEditUnassignedShift = (unassignedShift: UnassignedShift): boolean => {
  const policyKey = 'shift_management.update_unassigned_shifts'
  const targets = !!unassignedShift ? [unassignedShift] : []

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { loading } = useAsyncData(
    () => policyAuthorizations.authorizePolicies(policyKey, targets),
    [unassignedShift.id]
  )

  return policyAuthorizations.for(policyKey, unassignedShift)
}
